export enum OrganizationTemplateRubricSuggestionType {
  hyperlink = "hyperlink",
  overused_phrases = "overused_phrases",
  call_to_action = "call_to_action",
  opening_hook = "opening_hook",
  social_proof = "social_proof",
  merge_tags = "merge_tags",
  link_accuracy = "link_accuracy",
}

export const SUGGESTION_TYPE_LABELS: Record<string, string> = {
  [OrganizationTemplateRubricSuggestionType.hyperlink]: "Hyperlink",
  [OrganizationTemplateRubricSuggestionType.overused_phrases]:
    "Overused phrase",
  [OrganizationTemplateRubricSuggestionType.call_to_action]: "Call to action",
  [OrganizationTemplateRubricSuggestionType.opening_hook]: "Opening hook",
  [OrganizationTemplateRubricSuggestionType.social_proof]: "Social proof",
  [OrganizationTemplateRubricSuggestionType.merge_tags]: "Personalization tag",
  [OrganizationTemplateRubricSuggestionType.link_accuracy]: "Link accuracy",
};
